import { z } from 'zod';

import { AppraisalId, PropertyId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';

export const AppraisalType = z.enum(['appraisal', 'bpo']);
export type AppraisalType = z.infer<typeof AppraisalType>;

export const AppraisalMethod = z.enum([
  'automatedValuationModel',
  'desktopAppraisal',
  'driveBy',
  'fullAppraisal',
  'priorAppraisalUsed',
  'deskReview',
  'fieldReview',
  'hybridAppraisal',
  'none',
  'other',
]);
export type AppraisalMethod = z.infer<typeof AppraisalMethod>;

export const Appraisal = z.object({
  id: zodBrandedUuid<AppraisalId>(),
  propertyId: zodBrandedUuid<PropertyId>(),
  amount: z.number().positive(),
  date: zodDateOrString,
  type: AppraisalType,
  method: AppraisalMethod.default('none'),
  orderId: z.string().optional(), // Used to associate with an advance
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
  isOriginal: z.boolean().optional(),
});

export type Appraisal = z.infer<typeof Appraisal>;

export const AppraisalInput = Appraisal.pick({ amount: true, date: true, type: true, method: true, orderId: true });
export type AppraisalInput = z.infer<typeof AppraisalInput>;
